import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { type ReviewRow } from 'entities/Review'
import { useReviewsListContext } from 'pages/reviews/context'
import { ReviewsRoutes } from 'pages/reviews/route/type'
import { columns } from 'pages/reviews/pages/all/ui/ReviewsListTable/columns'
import { getReviewActions } from 'pages/reviews/actions/getReviewActions'

export const ReviewsListTable = observer(() => {
  const { items, tableStore, scrollToTopTrigger, onSuccessDelete } = useReviewsListContext()

  const rows: ReviewRow[] = items.map((item) => {
    item.setActionsProps({
      actions: getReviewActions({
        item,
        onSuccessDelete: () => onSuccessDelete(item.id),
      }),
      showItems: 0,
      noVisibleActions: true,
    })
    return item
  })

  return (
    <Table
      ariaLabel={'ReviewsList'}
      pinnedColumnIds={['name']}
      store={tableStore}
      columns={columns}
      rows={rows}
      getRowLink={(row) => `/${ReviewsRoutes.root}/${ReviewsRoutes.view}/${row.id}`}
      scrollToTOpTrigger={scrollToTopTrigger}
    />
  )
})
